import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, BookOpen, Sparkles } from 'lucide-react';
const comparisonData = [{
  situation: 'Primer mes de propiedad',
  without: 'Esperás que algo falle',
  with: 'Service de la Verdad en 15 días'
}, {
  situation: 'Presupuesto del taller',
  without: 'Pagás lo que te digan',
  with: 'Los 5 trucos para inflar precios y cómo frenarlos'
}, {
  situation: 'Costos anuales',
  without: 'Gastos imprevisibles',
  with: 'Calendario con costo estimado por mes'
}, {
  situation: 'Reventa futura',
  without: 'Precio de mercado',
  with: 'Carpeta de valor real que justifica un 15% más'
}];
export function ComparisonTable() {
  return <section className="py-14 bg-graphite border-y border-petroleum relative overflow-hidden" data-id="element-61">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-62"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-63">
        {/* Header inside gold frame */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-64">
          <div className="absolute -inset-1 bg-gradient-to-r from-gold via-yellow-400 to-gold rounded-3xl blur-xl opacity-30 animate-pulse" data-id="element-65"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-gold rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-gold/20" data-id="element-66">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(255,193,7,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,193,7,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-67"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-gold rounded-tl-3xl pointer-events-none" data-id="element-68"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-gold rounded-tr-3xl pointer-events-none" data-id="element-69"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-gold rounded-bl-3xl pointer-events-none" data-id="element-70"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-gold rounded-br-3xl pointer-events-none" data-id="element-71"></div>

            <div className="relative z-10" data-id="element-72">
              <div className="inline-flex items-center gap-2 bg-gold text-graphite px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-gold/40" data-id="element-73">
                <BookOpen className="w-3.5 h-3.5" data-id="element-74" />
                Protocolo Post-Compra
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-75">
                <span className="text-white" data-id="element-76">¿Qué agrega el </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-gold to-yellow-500 drop-shadow-[0_0_12px_rgba(255,193,7,0.4)]" data-id="element-77">
                  Protocolo Post-Compra?
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-gold to-transparent opacity-70" data-id="element-78"></div>
            </div>
          </div>
        </motion.div>

        {/* Desktop comparison table */}
        <div className="max-w-5xl mx-auto mb-10 hidden md:block" data-id="element-79">
          <div className="relative bg-petroleum border border-white/10 rounded-2xl overflow-hidden shadow-xl machined-edge" data-id="element-80">
            {/* Gold accent for winning column */}
            <div className="absolute top-0 bottom-0 right-0 w-1/3 bg-gradient-to-b from-gold/10 via-gold/[0.04] to-gold/10 pointer-events-none" data-id="element-81"></div>

            <table className="w-full text-left border-collapse relative" data-id="element-82">
              <thead data-id="element-83">
                <tr className="bg-graphite/70" data-id="element-84">
                  <th className="p-5 border-b border-white/10 text-textsecondary font-semibold text-xs uppercase tracking-widest w-2/5" data-id="element-85">
                    Situación
                  </th>
                  <th className="p-5 border-b border-white/10 text-electric font-semibold text-xs uppercase tracking-widest" data-id="element-86">
                    <span className="inline-flex items-center gap-2" data-id="element-87">
                      <span className="w-6 h-6 rounded-md bg-electric/15 flex items-center justify-center" data-id="element-88">
                        <X className="w-3.5 h-3.5" data-id="element-89" />
                      </span>
                      Sin el Protocolo
                    </span>
                  </th>
                  <th className="p-5 border-b-2 border-gold text-gold font-extrabold text-xs uppercase tracking-widest bg-gold/10 relative" data-id="element-90">
                    <span className="inline-flex items-center gap-2" data-id="element-91">
                      <span className="w-6 h-6 rounded-md bg-gold/25 flex items-center justify-center" data-id="element-92">
                        <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-93" />
                      </span>
                      Con el Protocolo
                      <Sparkles className="w-3.5 h-3.5 text-gold" data-id="element-94" />
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-95">
                {comparisonData.map((row, i) => <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02] transition-colors group" data-id="element-96">
                    <td className="p-5 text-white font-medium align-top" data-id="element-97">
                      <span className="inline-flex items-start gap-3" data-id="element-98">
                        <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center mt-0.5" data-id="element-99">
                          {i + 1}
                        </span>
                        {row.situation}
                      </span>
                    </td>
                    <td className="p-5 text-textsecondary align-top" data-id="element-100">
                      <span className="inline-flex items-start gap-2" data-id="element-101">
                        <X className="w-4 h-4 text-electric/70 shrink-0 mt-0.5" data-id="element-102" />
                        {row.without}
                      </span>
                    </td>
                    <td className="p-5 text-white font-semibold align-top bg-gold/[0.06] group-hover:bg-gold/[0.10] transition-colors border-l border-gold/20" data-id="element-103">
                      <span className="inline-flex items-start gap-2" data-id="element-104">
                        <Check className="w-4 h-4 text-gold shrink-0 mt-0.5" strokeWidth={3} data-id="element-105" />
                        {row.with}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile comparison cards */}
        <div className="max-w-2xl mx-auto mb-10 md:hidden space-y-4" data-id="element-106">
          {comparisonData.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-petroleum border border-white/10 rounded-2xl overflow-hidden shadow-lg" data-id="element-107">
              <div className="px-5 py-3 bg-graphite/60 border-b border-white/10 flex items-center gap-2.5" data-id="element-108">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-graphite border border-white/10 text-textsecondary text-xs font-bold flex items-center justify-center" data-id="element-109">
                  {i + 1}
                </span>
                <p className="text-white font-semibold text-sm" data-id="element-110">
                  {row.situation}
                </p>
              </div>
              <div className="grid grid-cols-2 divide-x divide-white/10" data-id="element-111">
                <div className="p-4" data-id="element-112">
                  <div className="inline-flex items-center gap-1.5 text-electric text-[10px] font-bold uppercase tracking-wider mb-2" data-id="element-113">
                    <X className="w-3 h-3" data-id="element-114" /> Sin el Protocolo
                  </div>
                  <p className="text-textsecondary text-sm" data-id="element-115">{row.without}</p>
                </div>
                <div className="p-4 bg-gold/[0.06]" data-id="element-116">
                  <div className="inline-flex items-center gap-1.5 text-gold text-[10px] font-bold uppercase tracking-wider mb-2" data-id="element-117">
                    <Check className="w-3 h-3" strokeWidth={3} data-id="element-118" /> Con el
                    Protocolo
                  </div>
                  <p className="text-white text-sm font-semibold" data-id="element-119">{row.with}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}